import {
    Box,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Text,
} from "@chakra-ui/react";
import React from "react";
import Player from "../../vdoPlayer/player";
import { useEffect, useState } from "react";
import axiosInstance from "../../../helpers/api";

const VideoPreviewModal = ({ isOpen, onClose, videoData }) => {
    const [loading, setLoading] = useState(true);
    const [otp, setOtp] = useState("");
    const [playBack, setPlayBack] = useState("");
    const getVideoData = async (id) => {
        const res = await axiosInstance.get(`/admin/videos/otp/${id}`);

        await setOtp(res?.data?.otp);
        await setPlayBack(res?.data?.playbackInfo);
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 2000);
    };

    useEffect(() => {
        if (videoData?.id) getVideoData(videoData?.id); 
    }, [videoData?.id]) // Add dependency array with videoData.id
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="xl">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{videoData?.title}</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <Box bg="gray" w="100%" borderRadius="8px" mb={4}>
                        {videoData?.video_type == 0 ? (
                            <div dangerouslySetInnerHTML={{ __html: videoData?.url }}></div>
                        ) : (
                            <Player
                                otp={otp}
                                playbackInfo={playBack}
                                data={videoData}
                            />
                        )}
                    </Box>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default VideoPreviewModal;